
import React from 'react'
import { Route, Redirect } from 'react-router-dom'
import { getToken } from './'

const Auth = {
	isAuthenticated: () => {
		const token = getToken()
		return !!token
	}
}

const GetPathname = (props) => {
	let pathname = "room"
	// console.log("000000", props.location)
	if (props && props.location && props.location.pathname) {
		// console.log("1111111", props.location.pathname)
		// pathname = props.location.pathname.replace('/', "")
		let setPath = props.location.pathname.replace('/', "")
		if (setPath) {
			pathname = setPath
		}
	}
	return pathname
}


const PrivateRoute = ({ component: Component, ...rest }) => (
	<Route {...rest} render={(props) => {

		if (Auth.isAuthenticated() === false && props.match.url !== "/login") {
			// console.log("999999",)
			return <Redirect to={`/login/${GetPathname(props)}`} />
		}

		if (Component !== undefined) {
			return <Component {...props} />
		} else {
			return <Redirect to='/' />
		}
	}} />
)

const PublicRoute = ({ component: Component, ...rest }) => {
	return <Route {...rest} render={(props) => {

		if (Auth.isAuthenticated() === true && props.match.url === "/login") {
			return <Redirect to='/' />
		}

		if (Auth.isAuthenticated() === true && props.match.url === "/") {
			return <Redirect to='/' />
		}

		if (Component !== undefined) {
			return <Component {...props} />
		} else {
			return ""
		}
	}} />
}

export {
	PrivateRoute,
	PublicRoute,
	Auth,
}


// WEBPACK FOOTER //
// ./src/display/lib/routePermission.js